// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSLabelValueList/index.less
// module id = 782
// module chunks = 42